var _path, _path2, _path3, _line, _line2, _line3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSolutions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 282,
    viewBox: "0 0 215 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.798 58.2188V204.557",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.353 278.806H20.5943C10.9894 278.806 3.20164 271.035 3.20164 261.452V20.5479C3.20164 10.9646 10.9894 3.19446 20.5943 3.19446H158.467",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.467 3.19446L211.798 58.2188H158.467V3.19446Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 100.5,
    x2: 178,
    y2: 100.5,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 135.5,
    x2: 178,
    y2: 135.5,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 177.5,
    x2: 121,
    y2: 177.5,
    stroke: "black",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8507_50844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179 205C159.113 205 143 221.113 143 241C143 260.887 159.113 277 179 277C198.887 277 215 260.887 215 241C215 221.113 198.887 205 179 205ZM197.51 229.476L177.776 255.915C177.292 256.578 176.527 256.986 175.711 257.037C175.635 257.037 175.584 257.037 175.507 257.037C174.768 257.037 174.028 256.731 173.518 256.195L161.918 244.595C160.822 243.499 160.822 241.688 161.918 240.592C163.014 239.496 164.824 239.496 165.921 240.592L175.201 249.873L192.997 226.059C193.941 224.81 195.7 224.555 196.949 225.473C198.198 226.416 198.453 228.176 197.51 229.425V229.476Z",
    fill: "#4BB649"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8507_50844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(143 205)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolutions);
export default __webpack_public_path__ + "static/media/ic_solutions.508874d0c001d3c81ba52872a002910c.svg";
export { ForwardRef as ReactComponent };